export default "__VITE_ASSET__76a9021e__"